import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Message } from 'react-frontier';
import { useBreadcrumbs } from '../Hooks';
import PromoterForm from '../components/PromoterForm';

var ProspectFormView = ()=>{
	var { prospect_id } = useParams<{ prospect_id: string }>();
	var { setTitle } = useBreadcrumbs();
	var pid = parseInt(prospect_id);

	useEffect(()=>{
		setTitle('Formulario');
	}, [prospect_id]);

	if(!pid || isNaN(pid)){
		return <Message type='error' header='ID inválido' style={{ maxWidth: 600, margin: '20px auto' }}>
			El identificador del prospecto no es válido.
		</Message>;
	}

	return <div style={{ maxWidth: 900, margin: 'auto', padding: '20px 0' }}>
		<PromoterForm prospect_id={pid} mode='admin' />
	</div>;
}

export default ProspectFormView;
